module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var item = widget.item || {}; 
    ; __append("\n\n<div class=\"spl-popup\">\n    <div class=\"spl-popup-header\">\n        <div class=\"spl-popup-subtitle\">\n            ")
    ; __append(escapeFn( item.classname ))
    ; __append("\n        </div>\n        <div class=\"spl-popup-title\">\n            ")
    ; __append(escapeFn( item.name ))
    ; __append("\n        </div>\n    </div>\n    <div class=\"spl-popup-body\">\n        <div class=\"spl-obj\">\n            ")
    ;  if (widget.content != null) { 
    ; __append("\n\n            ")
    ; __append( widget.content )
    ; __append("\n\n            ")
    ;  } else { 
    ; __append("\n\n            ")
    ;  if (!_.isEmpty(item.coordinate)) { 
    ; __append("\n            <div>\n                <div class=\"spl-obj-geog\">\n                    <small>\n                        ")
    ; __append(escapeFn( item.coordinate.join(" ") ))
    ; __append("\n                    </small>\n                </div>\n            </div>\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if (item.addresscode || item.addresstext) { 
    ; __append("\n            <div class=\"spl-obj-address\">\n                ")
    ; __append(escapeFn( [item.addresscode, item.addresstext].filter(_.identity).join(", ") ))
    ; __append("\n            </div>\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if (!_.isEmpty(item.attributes)) { 
    ; __append("\n            <div class=\"spl-obj-data\">\n                ")
    ;  _.each(item.attributes, function(attribute) { 
    ; __append("\n                <div class=\"spl-obj-data-row flex\">\n                    <div class=\"spl-obj-data-key flex-item\">\n                        <span>")
    ; __append(escapeFn( attribute.name ))
    ; __append("</span>\n                    </div>\n\n                    <div class=\"spl-obj-data-val flex-item\">\n                        <span>")
    ; __append(escapeFn( attribute.value ))
    ; __append("</span>\n                    </div>\n                </div>\n                ")
    ;  }) 
    ; __append("\n            </div>\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  } 
    ; __append("\n        </div>\n    </div>\n    <div class=\"spl-popup-footer\">\n        ")
    ;  if (Util.coalesce(widget.readMore, true)) { 
    ; __append("\n        <div class=\"spl-edit-tool\">\n            <span name=\"info\" class=\"underline\"\n                  data-layer=\"")
    ; __append(escapeFn( item.classid ))
    ; __append("\"\n                  data-item=\"")
    ; __append(escapeFn( item.id ))
    ; __append("\" on-click=\"onReadMoreClick\">\n                Подробнее\n            </span>\n        </div>\n        ")
    ;  } 
    ; __append("\n    </div>\n</div>\n")
  }
  return __output.join("");

}